const setToken = (state, {token}) => {
  state.token = token;
};

const setUser = (state, user) => {
  state.user = user;
};

const setClient = (state, client) => {
  state.client = client;
};

const removeToken = (state) =>{
  state.token = null;
};

export default {
  setToken,
  removeToken,
  setUser,
  setClient
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js